<template>
  <div class="f-column">
    <GwTitleTooltip
      v-if="hasTitle"
      class="mt-2 theme-block-title"
      :title="$t('settings.grouping_actions')"
      :tooltip="$t('tooltips.grouping_actions')"
    />
    <SettingsCheckbox
      v-if="hasPersist"
      settingsKey="switchersDefaults.sw_actions_grouping"
      :title="$t('settings.persist_actions_grouping')"
      :tooltip="$t('tooltips.persist_actions_grouping')"
      :customGet="
        () => {
          return !$store.getters.mergedUserSettings.switchersDefaults.sw_actions_grouping
        }
      "
      :customSet="
        value => {
          const switchersDefaults = { sw_actions_grouping: !value ? 'swv_grouping_none' : null }
          $store.dispatch('userSettings', { switchersDefaults })
        }
      "
    />
    <div
      v-if="hasOptions"
      class="d-flex"
      :class="{ 'mt-2': hasOptions }"
    >
      <GwBtns
        :options="l_options"
        :value="l_activeOption.payload"
        idKey="payload"
        class="gwbtns_horizontal_grey"
        style="
          background: var(--clr-black-1-3);
          border-radius: 4px;
          --gwbtn-size: 1rem;
          --gwbtn-height: 1.875rem;
          --gwbtns-wrap: wrap;
          --gwbtns-padding: 2px;
        "
        @click="toggle"
      >
        <template #default="{ item }">
          {{ item.text }}
        </template>
      </GwBtns>
    </div>
    <div
      v-if="hasOptions"
      class="text-smallest text-grey ml-1 mt-2"
      v-html="
        $t('common.press_hotkey_to_switch', {
          key: hotkeys.switch_actions_grouping.displayCombination,
        })
      "
    ></div>

    <div
      v-if="hasPreview"
      class="simple-action-btns ursetappr_preview"
      :class="{ 'mt-2': hasOptions }"
    >
      <div
        v-for="action in l_solution"
        :key="action.hex"
        class="simple-action-btn z-index_3 position-relative"
        :class="action.css_class"
      >
        <div v-if="action.group_display_name">
          {{ $t(`browse.${action.group_display_name}`) }}
        </div>
        <div
          v-else
          v-html="
            getBetHtml({
              showBetsIn,
              a: action,
            })
          "
        ></div>
        <!-- {{ action.display_name }}
          {{
            showBetsIn === 'pot' && action.amount_by_pot
              ? `${action.amount_by_pot}%`
              : action.raise_amount
          }}
          <div
            class="text-smallest line-height_1 pb-1"
            v-if="showBetsIn === 'bb_and_pot' && action.amount_by_pot"
          >
            {{ action.amount_by_pot }}%
          </div>
          -->
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import SettingsCheckbox from '@/components/Dialogs/UserSettingsDialog/SettingsCheckbox'
import GwBtns from '@/components/lib/GwBtns'
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import { allSwitchers } from '@/store/switchers/switchers'
import prompt_mix from '@/mixins/prompt_mix'
import { getGroupedActions } from '@/helpers/grouping'

export default {
  name: 'SettingsActionsGrouping',
  components: {
    GwTitleTooltip,
    SettingsCheckbox,
    GwBtns,
  },
  mixins: [float_mix, prompt_mix, format_mix],
  props: {
    hasTitle: { type: Boolean, default: true },
    hasOptions: { type: Boolean, default: true },
    hasPreview: { type: Boolean, default: true },
    hasPersist: { type: Boolean, default: true },
  },
  data() {
    this.swKey = 'sw_actions_grouping'
    return {}
  },
  methods: {
    toggle(_e, item) {
      this.$store.dispatch('switchers_set_item', {
        key: this.swKey,
        item,
      })
    },
    toggleThreeWay() {
      const opts = this.l_options
      // let opts = this.l_options.filter(i => !i.disabled)
      const idx = opts.findIndex(i => i.value)
      const item = opts[idx + 1] || opts[0]
      this.toggle(undefined, item)
    },
  },

  computed: {
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    l_solution() {
      const actions = [
        {
          code: 'RAI',
          type: 'RAISE',
          display_name: 'Allin',
          betsize: 97.5,
          raise_group: 'bet_overbet',
          raise_amount: 97.5,
          amount_by_pot: 1773,
          css_var: '--clr-R4',
          css_class: 'R4',
          hex: '#ab1717',
          // hex_default: '#0ab171',
          frequency: 0.25,
        },
        {
          code: 'R4',
          type: 'RAISE',
          display_name: 'Bet',
          betsize: 4,
          raise_group: 'bet_large',
          raise_amount: 4,
          amount_by_pot: 73,
          css_var: '--clr-R3',
          css_class: 'R3',
          hex: '#c22929',
          // hex_default: '#0c2292',
          frequency: 0.25,
        },
        {
          code: 'R1.5',
          type: 'RAISE',
          display_name: 'Bet',
          betsize: 1.5,
          raise_group: 'bet_small',
          raise_amount: 1.5,
          amount_by_pot: 27,
          css_var: '--clr-R1',
          css_class: 'R1',
          hex: '#f55353',
          // hex_default: '#0f5535',
          frequency: 0.25,
        },
        // {
        //   code: 'X',
        //   type: 'CHECK',
        //   display_name: 'Check',
        //   css_var: '--clr-X',
        //   css_class: 'X',
        //   hex: '#5ab966',
        //   hex_default: '#5ab966',
        //   frequency: 0.25,
        // },
      ]

      const res = getGroupedActions({
        actions,
        grouping: this.l_activeOption.payload,
        groupValues: ['frequency'],
        raisesFirst: true,
      })
      // console.log(res)
      return res
    },
    showBetsIn() {
      const { show_bets_in } = this.$store.getters
      return show_bets_in
    },
    l_options() {
      const all = allSwitchers()
      let res = all[this.swKey]
      res = res.map(i => {
        const r = {
          ...i,
          text: this.$t(`switchers.${i.payload}`),
          value: i.payload === this.$store.getters[this.swKey],
        }
        return r
      })
      // console.log(res)
      return res
    },
    l_activeOption() {
      const res = this.l_options.find(i => i.value) || { ...this.l_options[0], value: true }
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.simple-action-btns {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 0.25rem;
}
.simple-action-btn {
  display: flex;
  align-items: center;
  justify-items: center;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  color: var(--clr-white-0);
  font-size: 1rem;
  text-shadow: var(--action-btn-text-shadow);
  font-weight: 500;
}
</style>
